function isSpecialInput(input) {
    return input.type === 'tel' ||
           input.type === 'date' ||
           input.classList.contains('js-inputMasketDate') ||
           input.dataset.intlTelInputId !== undefined;
}

function handleFocus(input, inputGroup, infieldInputGroup) {
    inputGroup.classList.add("is-focus");
    if (infieldInputGroup) {
        infieldInputGroup.classList.add("is-focus");
    }
}

function handleBlur(input, inputGroup, infieldInputGroup) {
    if (!isSpecialInput(input)) {
        inputGroup.classList.remove("is-focus");
        if (infieldInputGroup) {
            infieldInputGroup.classList.remove("is-focus");
        }
    }
}

function handleInput(input) {
    checkFilledInput(input);
}

export function focusInputGroups(query = document.querySelectorAll('.inputGroup input,.inputGroup select,.inputGroup textarea')) {
    for (let input of query) {
        let inputGroup = input.closest(".inputGroup");
        let infieldInputGroup = input.closest(".infieldInputGroup");

        checkFilledInput(input);

        input.addEventListener("focus", () => handleFocus(input, inputGroup, infieldInputGroup));
        input.addEventListener("blur", () => handleBlur(input, inputGroup, infieldInputGroup));
        input.addEventListener("input", () => handleInput(input));
    }
}

export function checkFilledInput(input) {
    let inputGroup = input.closest(".inputGroup");
    let infieldInputGroup = input.closest(".infieldInputGroup");

    function updateInputClasses() {
        let hasValue;
        try {
            hasValue = input.matches(':autofill');
        } catch (err) {
            try {
                hasValue = input.matches(':-webkit-autofill');
            } catch (er) {
                hasValue = false;
            }
        }
        const isFilled = input.value !== "" || hasValue;

        const specialInput = isSpecialInput(input);

        if (inputGroup) {
            if (specialInput) {
                inputGroup.classList.add("is-filled");
            } else {
                if (isFilled) {
                    inputGroup.classList.add("is-filled");
                } else {
                    inputGroup.classList.remove("is-filled");
                }
            }
        }

        if (infieldInputGroup) {
            if (specialInput) {
                infieldInputGroup.classList.add("is-filled");
            } else {
                if (isFilled) {
                    infieldInputGroup.classList.add("is-filled");
                } else {
                    infieldInputGroup.classList.remove("is-filled");
                }
            }
        }

        if (input.dataset.intlTelInputId !== undefined) {
            if (inputGroup) inputGroup.classList.add("is-focus");
            if (infieldInputGroup) infieldInputGroup.classList.add("is-focus");
        }
    }

    updateInputClasses();
    const observer = new MutationObserver(updateInputClasses);
    observer.observe(input, { attributes: true, attributeFilter: ['class', 'autofill'] });

    const intervalId = setInterval(updateInputClasses, 200);

    input.addEventListener('focus', updateInputClasses);

    setTimeout(() => {
        clearInterval(intervalId);
        observer.disconnect();
        input.removeEventListener('focus', updateInputClasses);
    }, 5000);

    return () => {
        clearInterval(intervalId);
        observer.disconnect();
        input.removeEventListener('focus', updateInputClasses);
    };
}